import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import AssetFormContent from "./assetFormContent";
import {
  getAssetDetail,
  saveAssetDirectInput,
} from "../../../../../services/finance/finance";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
import { setObject } from "../../../../../utils/utils";
import { DateTime } from "luxon";
const assetFormSchema = yup.object().shape({
  ID: yup.number(),
  assetCode: yup
    .string()
    .required("Asset Code is required")
    .max(255, "Asset Code maximum characters is 255"),
  itemName: yup.string().required("Asset Name is required"),
  assetDesc: yup.string(),
  purchaseDate: yup
    .date()
    .required("Purchase Date is required")
    .max(
      yup.ref("receivedDate"),
      "Purchase Date must be less equal to Received Date"
    ),
  receivedDate: yup
    .date()
    .required("Received Date is required")
    .min(
      yup.ref("purchaseDate"),
      "Received Date must be greater equal to Purchase Date"
    ),
  qty: yup
    .number()
    .integer("Quantity must be integer")
    .transform((value) => (isNaN(value) ? 0 : value))
    .nullable()
    .required("Quantity is required")
    .moreThan(0, "Quantity cannot be zero or empty")
    .default(0),
  uomName: yup.string().required("Unit is required"),
  assetOriginType: yup.number(),
  unitValueAmount: yup
    .number()
    .transform((value) => (isNaN(value) ? 0 : value))
    .nullable()
    .min(1, "Unit Asset value is required")
    .default(0),
  unitPrice: yup.number().when("assetOriginType", {
    is: (value) => value === 1,
    then: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .required("Unit Price is required")
      .min(1, "Unit Price cannot be zero or empty")
      .default(0),
  }),
  totalPrice: yup.number().when("assetOriginType", {
    is: (value) => value === 1,
    then: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .required("Total Price is required")
      .min(1, "Total Price cannot be zero or empty")
      .default(0),
  }),
});
function AssetForm({ assetStockID = 0, onConfirmSave, onCloseDialog }) {
  const { socket } = useGlobalData();
  const [asset, setAsset] = useState({
    ID: 0,
    vendorID: 0,
    vendorName: "",
    assetOriginType: 1,
    assetOriginTypeName: "",
    itemID: 0,
    itemType: 0,
    itemTypeName: "",
    assetCode: "",
    itemName: "",
    qty: 0,
    assetDesc: "",
    currencyID: 0,
    unitPrice: 0,
    totalPrice: 0,
    unitValueAmount: 0,
    totalValueAmount: 0,
    uomID: 0,
    uomName: "",
    receivedDate: DateTime.now().startOf("day"),
    purchaseDate: DateTime.now().startOf("day"),
    depreciationStatus: 0,
    depreciationStatusDesc: "",
    disposalStatus: 0,
    disposalStatusDesc: "",
    incomeAccountID: 0,
    incomeAccountName: "",
    cashAccountID: 0,
    cashAccountName: "",
    fixAssAccountID: 0,
    fixAssAccountName: "",
    accDepAccountID: 0,
    accDepAccountName: "",
    depExAccountID: 0,
    depExAccountName: "",
    unitDepAmount: 0,
    totalDepAmount: 0,
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  async function getAssetDetailData(assetStockID = 0) {
    const response = await getAssetDetail(assetStockID);
    const { data } = response.data;
    const { assetStock, batch } = data;

    setAsset({
      ID: assetStock.ID,
      vendorID: assetStock.vendorID,
      vendorName: assetStock.vendor.vendorName,
      assetOriginType: assetStock.assetOriginType,
      assetOriginTypeName: assetStock.assetOriginTypeName,
      itemID: assetStock.itemID,
      itemType: assetStock.itemType,
      itemTypeName: assetStock.itemTypeName,
      assetCode: assetStock.assetCode,
      itemName: assetStock.itemName,
      qty: assetStock.qty,
      assetDesc: assetStock.assetDesc,
      currencyID: assetStock.currencyID,
      unitPrice: batch.unitCost,
      totalPrice: batch.unitCost * assetStock.qty,
      unitValueAmount: assetStock.unitValueAmount,
      totalValueAmount: assetStock.totalValueAmount,
      uomID: assetStock.uomID,
      uomName: assetStock.uom.uomName,
      receivedDate: assetStock.receivedDate,
      purchaseDate: assetStock.purchaseDate,
      depreciationStatus: assetStock.depreciationStatus,
      depreciationStatusDesc: assetStock.depreciationStatusDesc,
      disposalStatus: assetStock.disposalStatus,
      disposalStatusDesc: assetStock.disposalStatusDesc,
      fixAssAccountID: assetStock.fixAssAccountID,
      fixAssAccountName: assetStock.fixAssAccountName,
      accDepAccountID: assetStock.accDepAccountID,
      accDepAccountName: assetStock.accDepAccountName,
      depExAccountID: assetStock.depExAccountID,
      depExAccountName: assetStock.depExAccountName,
      cashAccountName: assetStock.cashAccountName,
      incomeAccountName: assetStock.incomeAccountName,
      unitDepAmount: assetStock.unitDepAmount,
      totalDepAmount: assetStock.totalDepAmount,
      totalDepAmount: assetStock.totalDepAmount,
      CreatedAt: assetStock.CreatedAt,
      UpdatedAt: assetStock.UpdatedAt,
      createdBy: assetStock.createdBy,
      updatedBy: assetStock.updatedBy,
    });
  }

  useEffect(() => {
    const { auth } = store.getState();

    if (assetStockID > 0) {
      setObject(socket, "lock", assetStockID, "ASST", auth.user)
        .then((response) => {
          getAssetDetailData(assetStockID);
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (assetStockID > 0) {
        setObject(socket, "release", assetStockID, "ASST", auth.user);
      }
    };
  }, [assetStockID]);

  return (
    <AppForm
      headSubmitButton={false}
      initialValues={asset}
      validationSchema={assetFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.qty = parseFloat(values.qty);
        values.unitPrice = parseFloat(values.unitPrice);
        values.totalPrice = parseFloat(values.totalPrice);
        values.unitValueAmount = parseFloat(values.unitValueAmount);
        values.totalValueAmount = parseFloat(values.totalValueAmount);
        values.unitDepAmount = parseFloat(values.unitDepAmount);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Asset ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveAssetDirectInput(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <AssetFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default AssetForm;
